import { isClientSide } from "@helper/utils";
import { useEffect } from "react";

export default function useAdsControl() {
  useEffect(() => {
    if (!isClientSide) return;

    window.hideCatfishAd = () => {
      document.body.classList.toggle("hide-mobile-ads");
    };
    window.showCatfishAd = () => {
      document.body.classList.remove("hide-mobile-ads");
    };
    return () => {
      delete window.hideCatfishAd;
      delete window.showCatfishAd;
    };
  }, []);

  useEffect(() => {
    if (!isClientSide) return;
    window.addEventListener(
      "overlay:prioritize",
      (event: CustomEvent<ICustomEvent>) => {
        sphwavePrioritize(event);
      },
    );
    window.addEventListener(
      "overlay:deprioritize",
      (event: CustomEvent<ICustomEvent>) => {
        sphwaveDeprioritize(event);
      },
    );

    return () => {
      if (!isClientSide) return;
      window.removeEventListener("overlay:prioritize", sphwavePrioritize);
      window.removeEventListener("overlay:deprioritize", sphwaveDeprioritize);
    };
  }, []);
}

function sphwavePrioritize(e: CustomEvent<ICustomEvent>) {
  if (!isClientSide) return;
  const { id } = e.detail;

  if (id === "eshop-onsite-checkout") window.hideCatfishAd?.();
}

function sphwaveDeprioritize(e: CustomEvent<ICustomEvent>) {
  if (!isClientSide) return;
  const { id } = e.detail;

  if (id === "eshop-onsite-checkout") window.showCatfishAd?.();
}

declare global {
  interface WindowEventMap {
    "overlay:prioritize": CustomEvent<ICustomEvent>;
    "overlay:deprioritize": CustomEvent<ICustomEvent>;
  }
}

interface ICustomEvent {
  id: string;
}
